import { render, staticRenderFns } from "./MoneyBoxes.vue?vue&type=template&id=1eff959c"
import script from "./MoneyBoxes.vue?vue&type=script&lang=js"
export * from "./MoneyBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports